var React = require('react');

function PrevArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_85","data-name":"Path 85","d":"M303.5,2530l-11-11,11-11","transform":"translate(-290.379 -2506.939)","fill":"none","stroke":"#e65300","strokeMiterlimit":"10","strokeWidth":"3","fillRule":"evenodd"}));
}

PrevArrow.defaultProps = {"width":"14.182","height":"24.121","viewBox":"0 0 14.182 24.121"};

module.exports = PrevArrow;

PrevArrow.default = PrevArrow;
